export enum AlignItems {
  Baseline = 'baseline',
  Center = 'center',
  End = 'end',
  FlexEnd = 'flex-end',
  FlexStart = 'flex-start',
  Normal = 'normal',
  SafeCenter = 'safe center',
  SelfEnd = 'self-end',
  SelfStart = 'self-start',
  Start = 'start',
  Stretch = 'stretch',
}
